import { createFileRoute } from '@tanstack/react-router';

import { ChangelogPage } from '@/pages/help/changelog-page';

export const Route = createFileRoute('/changelog')({
  component: ChangelogPage,
});
